import { Component, ComponentFactoryResolver, Inject, Injector } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'

import { ConfigType } from '@app/core/constants/configType'
import { Message } from '@shared/models/message.model'
import { AbstractDialogComponent } from '@shared/dialogs/abstract-dialog.component'

@Component({
  template: `
    <div class="message-container">
      <mat-toolbar matDialogTitle>
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center" [ngClass]="messageClass">
          <h1 matDialogTitle>
            @switch (message.type) {
              @case (configType.typeSuccess) {
                <span>{{ 'DIALOGS.MESSAGES.SUCCESS' | translate }}</span>
              }
              @case (configType.typeWarning) {
                <span>{{ 'DIALOGS.MESSAGES.WARNING' | translate }}</span>
              }
              @case (configType.typeError) {
                <span>{{ 'DIALOGS.MESSAGES.ERROR' | translate }}</span>
              }
            }
            @if (message.title) {
              <span>{{ message.title }}</span>
            }
          </h1>
          <button mat-button class="mat-icon-button" [mat-dialog-close]="false" aria-label="{{ 'DIALOGS.MESSAGES.CLOSE' | translate }}">
            <mat-icon svgIcon="close"></mat-icon>
          </button>
        </mat-toolbar-row>
      </mat-toolbar>

      <div mat-dialog-content>
        @if (message.subTitle) {
          <h4 class="mat-h1">{{ message.subTitle }}</h4>
        }
        <div class="message-content">
          @if (message.message) {
            <div class="mat-h3" fxLayoutAlign="center center">
              @if (message.shouldBeTranslated) {
                <div>
                  {{ message.message | translate }}
                </div>
              } @else {
                <p class="message">{{ message.message }}</p>
              }
            </div>
          }
        </div>
      </div>

      <div mat-dialog-actions fxLayoutAlign="center">
        <button [mat-dialog-close]="true" mat-raised-button [ngClass]="messageClass">
          <b>{{ 'BUTTONS.OK' | translate | uppercase }}</b>
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./message-dialog.component.scss'],
  standalone: false,
})
export class MessageDialogComponent extends AbstractDialogComponent {
  configType = ConfigType

  constructor(
    protected injector: Injector,
    @Inject(MAT_DIALOG_DATA) public message: Message,
  ) {
    super(injector, message)
  }

  get messageClass() {
    switch (this.message.type) {
      case ConfigType.typeSuccess:
        return 'success'
      case ConfigType.typeError:
        return 'error'
      case ConfigType.typeWarning:
        return 'warning'
    }
  }
}
